module.exports = __webpack_public_path__ + "static/img/b1-2-2.ff9f2c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-2-2.png
// module id = H1YP
// module chunks = 1